module.exports = __webpack_public_path__ + "static/media/comunity.1b2c98d4.svg";